import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import RepeatedLeadsTable from "../../../components/Lead/repeatedLeads"

const RepeatedLeads = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Repeated Leads | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <RepeatedLeadsTable />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default RepeatedLeads
